module.exports = __webpack_public_path__ + "static/media/1013260.63f25b26.png";